import { render } from "./CartMessageResultListItem.vue?vue&type=template&id=b04b5c68"
import script from "./CartMessageResultListItem.vue?vue&type=script&lang=js"
export * from "./CartMessageResultListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__